<div class="body">

    <mat-toolbar class="ams-toolbar">
        <button mat-icon-button>
            <mat-icon>person</mat-icon>
        </button>
        <span>Ansprechpartner auswählen</span>
        <span class="spacer"></span>
        <button mat-icon-button color="warn" (click)="close()">
            <mat-icon>close</mat-icon>
        </button>
    </mat-toolbar>

    <div class="content">

        <mat-form-field class="width" appearance="fill">

            <mat-label>Ansprechpartner suchen</mat-label>
            <input type="text" placeholder='Suchbegriff eingeben' matInput [formControl]="formControl"
                (keyup.enter)="search()" />
            <mat-icon matSuffix>search</mat-icon>

        </mat-form-field>

        <div class="results preview-entry-container" *ngIf="contacts.length > 0; else noContacts">

            <div class="preview-entry" *ngFor="let contact of contacts" (click)="contactClicked(contact)">
                <app-contact-preview [contact]="contact"></app-contact-preview>
            </div>

            <div class="load-more-wrapper" *ngIf="total > contacts.length">

                <button mat-raised-button (click)="loadMore()">
                    Mehr laden
                </button>

            </div>

        </div>

        <div class="footer">

            {{contacts.length}} von {{total}}

        </div>

    </div>

</div>

<ng-template #noContacts>

    <div class="no-contacts-hint">

        <div class="text">Keine Ansprechpartner gefunden</div>

    </div>

</ng-template>
